export default "__VITE_ASSET__CuMNSon___"